const radioDirectionOptions = {
  ROW: 'row',
  COL: 'col'
}

const radioVariantOptions = {
  STANDARD: 'standard',
  EMPHASIS: 'emphasis'
}

const radioSizeOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
}

const radioSizeOption = {
  [radioSizeOptions.SMALL]: {
    width: '10px',
    height: '10px',
    gap: '4px',
    borderWidth: 1.5,
    indicator: {
      width: '6.5px',
      height: '6.5px'
    }
  },
  [radioSizeOptions.MEDIUM]: {
    width: '12px',
    height: '12px',
    gap: '6px',
    borderWidth: 2,
    indicator: {
      width: '8px',
      height: '8px'
    }
  },
  [radioSizeOptions.LARGE]: {
    width: '20px',
    height: '20px',
    gap: '8px',
    borderWidth: 2,
    indicator: {
      width: '14px',
      height: '14px'
    }
  }
}

export { radioDirectionOptions, radioVariantOptions, radioSizeOptions, radioSizeOption }
